<!--<p>-->
<!--  The Jalali calendar is a solar calendar that was used in Persia.-->
<!--  Variants of it are still in use in Iran and Afghanistan-->
<!--</p>-->


<div class="w-100 text-center align-items-lg-stretch flex-wrap">
  <p class="text-center">{{lblText}}</p>
  <div class="col-12 p-1">
    <button  [value]="newDate"  class="btn large-btn" (click)="isDisabled = !isDisabled" >
      <span > <i class="fa fa-calendar" style="margin: 5px -90px 0 0;"></i> {{newDate ? newDate:''}}</span>
    </button>
  </div>
  <ngb-datepicker #d  [minDate]="minDate" *ngIf="isDisabled" [(ngModel)]="model" [firstDayOfWeek]="6" (dateSelect)="onClick($event); isDisabled= false"
                  class="m-auto d-bloc bg-white position-relative"
                  style="z-index: 4;margin-top: 38px;"></ngb-datepicker>
</div>


